import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["name", "content"]
const _hoisted_2 = ["property", "content"]
const _hoisted_3 = ["hreflang", "href"]
const _hoisted_4 = { class: "app-page" }
const _hoisted_5 = { class: "app-page__content" }

export function render(_ctx, _cache) {
  const _component_ecl_site_header_harmonised = _resolveComponent("ecl-site-header-harmonised")
  const _component_ecl_page_header_harmonised = _resolveComponent("ecl-page-header-harmonised")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ecl_footer_harmonised = _resolveComponent("ecl-footer-harmonised")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createElementVNode("title", null, _toDisplayString(_ctx.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (metaItem, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (metaItem.name)
            ? (_openBlock(), _createElementBlock("meta", {
                key: 0,
                name: metaItem.name,
                content: metaItem.content
              }, null, 8, _hoisted_1))
            : (metaItem.property)
              ? (_openBlock(), _createElementBlock("meta", {
                  key: 1,
                  property: metaItem.property,
                  content: metaItem.content
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, i) => {
        return (_openBlock(), _createElementBlock("link", {
          key: i,
          rel: "alternate",
          hreflang: language.code,
          href: language.url
        }, null, 8, _hoisted_3))
      }), 128))
    ])),
    _withDirectives(_createElementVNode("main", _hoisted_4, [
      _createVNode(_component_ecl_site_header_harmonised, {
        ref: "refHeader",
        className: _ctx.className,
        menuItems: _ctx.menuPrimary,
        siteName: "Rural toolkit",
        showLanguage: true,
        onPerformSearch: _ctx.performSearch
      }, null, 8, ["className", "menuItems", "onPerformSearch"]),
      _createVNode(_component_ecl_page_header_harmonised, {
        metaInfo: _ctx.metaInfo,
        description: _ctx.description,
        breadcrumbList: _ctx.breadcrumbList,
        breadcrumbEllipsisLimit: 0
      }, null, 8, ["metaInfo", "description", "breadcrumbList"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(_component_ecl_footer_harmonised, {
        siteName: { label: 'Rural toolkit', url: _ctx.baseUrl},
        contentOwnerDetail: _ctx.contentOwnerDetails,
        siteContentColumns: _ctx.footerSiteContentColumns,
        overrides: _ctx.footerOverrides
      }, null, 8, ["siteName", "contentOwnerDetail", "siteContentColumns", "overrides"])
    ], 512), [
      [_vShow, _ctx.i18nLoading === false]
    ])
  ], 64))
}